import { DollarCircleOutlined, ShoppingCartOutlined } from '@ant-design/icons';
import { Input } from 'antd';
import styled from 'styled-components';

export const MultipleWarning = styled.span`
  color: #f5222d;
  font-size: 13px;
  margin-top: 4px;
`;

export const ModalHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  padding: 0;
`;

export const TitleContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

export const DollarIcon = styled(DollarCircleOutlined)`
  color: #f78e1e;
  font-size: 24px;
`;

export const ShoppingCartIcon = styled(ShoppingCartOutlined)`
  color: #f78e1e;
  font-size: 24px;
`;

export const ModalTitle = styled.h2`
  margin: 0;
  font-size: 0.875rem;
  font-weight: 400;
  color: #000;
`;

export const CloseButton = styled.button`
  background: none;
  border: none;
  padding: 4px;
  cursor: pointer;
  color: #999;
  font-size: 1rem;

  &:hover {
    color: #000;
  }
`;

export const ModalContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
`;

export const ModalitySection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

export const ModalityLabel = styled.span`
  font-size: 1rem;
  color: #000;
  font-weight: 700;
`;

export const ModalityButtonsContainer = styled.div`
  display: flex;
  flex-direction: column;
  overflow: hidden;
  margin-bottom: 16px;

  .button-packing {
    width: 100%;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
  }

  .button-packing:not(:last-child) {
    border-bottom: 1px solid #d9d9d9;
  }
`;

export const QuantitySection = styled.div`
  .ant-form-item {
    margin-bottom: 0;
  }

  .ant-input-group {
    display: flex !important;
  }
`;

export const MainQuantityInput = styled(Input)`
  width: 100%;
  height: 48px;

  .ant-input {
    height: 100%;
    font-size: 16px;
    border: 2px solid #d9d9d9;

    &:focus {
      border-color: #f78e1e;
      box-shadow: 0 0 0 2px rgba(247, 142, 30, 0.1);
    }
  }

  .ant-input-group-addon {
    background: #f5f5f5;
    border: 2px solid #d9d9d9;
    border-left: none;
    font-weight: 500;
    min-width: 120px;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  @media (max-width: 768px) {
    .ant-input-group-addon {
      min-width: 100px;
      font-size: 14px;
    }
  }
`;

export const PurchaseInfo = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const PromoInfoRow = styled.div`
  color: #389e0d;
  font-size: 0.625rem;
  flex-wrap: wrap;
  padding-bottom: 16px;
  padding: 0 24px 16px;
  margin-left: -24px;
  margin-right: -24px;
`;

export const PurchaseInfoRow = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  font-size: 0.75rem;
  flex-wrap: wrap;
  border-bottom: 1px solid #d9d9d9;
  padding-bottom: 16px;
  padding: 0 24px 16px;
  margin-left: -24px;
  margin-right: -24px;
`;

export const InfoItem = styled.div`
  display: flex;
  gap: 1px;
  font-size: 10px;

  span:first-child {
    color: #595959;
  }

  span:last-child {
    color: #595959;
  }
`;

export const ShippingInfo = styled(InfoItem)`
  span {
    color: #f78e1e !important;
    font-weight: 700;
  }
`;

export const CompositionRow = styled.div`
  font-size: 0.75rem;
  color: #595959;
  padding: 4px 24px 0;
  margin-left: -24px;
  margin-right: -24px;
`;

export const TotalPedidoRow = styled.div`
  font-size: 0.75rem;
  color: #262626;
  font-weight: 600;
  margin-top: 4px;
  padding: 6px 10px;
  background: #fafafa;
  border: 1px solid #f0f0f0;
  border-radius: 4px;
`;

export const ActionButtons = styled.div`
  display: flex;
  gap: 12px;
  justify-content: flex-end;
  padding-top: 16px;
  flex-direction: row;
`;

export const ButtonTooltipWrapper = styled.span<{ isDisabled?: boolean }>`
  display: inline-flex;
  cursor: ${({ isDisabled }) => (isDisabled ? 'not-allowed' : 'auto')};

  > button {
    ${({ isDisabled }) => (isDisabled ? 'pointer-events: none;' : '')}
  }

  @media (max-width: 768px) {
    width: 100%;
  }
`;

export const CancelButton = styled.button`
  padding: 8px 24px;
  border: 1px solid #d9d9d9;
  background: white;
  color: #595959;
  border-radius: 6px;
  cursor: pointer;
  font-size: 14px;
  font-weight: 500;
  transition: all 0.2s;
  flex: 0;

  &:hover {
    border-color: #f78e1e;
    color: #f78e1e !important;
  }

  @media (max-width: 768px) {
    width: 100%;
    padding: 12px 24px;
  }
`;

export const BuyButton = styled.button`
  padding: 8px 24px;
  border: none;
  background: #f78e1e;
  color: white;
  border-radius: 6px;
  cursor: pointer;
  font-size: 14px;
  font-weight: 500;
  transition: all 0.2s;
  white-space: nowrap;
  flex: 0;

  &:hover {
    background: #e67010;
  }

  &:disabled {
    background: #f5f5f5;
    color: #bfbfbf;
    cursor: not-allowed;
  }

  @media (max-width: 768px) {
    width: 100%;
    padding: 12px 24px;
  }
`;
